import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { AnchorDirective, DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MessageType } from '../../../../model/message.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { DepositService } from '../../../../service/deposit.service';
import { GtmService } from '../../../../service/gtm.service';
import { ResizeService } from '../../../../service/resize.service';
import { UserDataService } from '../../../../service/userDataService';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-ada-message',
    templateUrl: 'ada-message.component.html',
    imports: [MessageComponent, TranslateModule, DynamicHtmlDirective, AnchorDirective],
})
export class ADAMessageComponent implements OnInit, OnDestroy {
    private behaviorData = inject(BehaviorDataService);
    private userdataService = inject(UserDataService);
    private GTMService = inject(GtmService);
    private depositService = inject(DepositService);
    private resizeService = inject(ResizeService);

    showAdaInteractionMessage: boolean;
    isCountryUK: boolean;
    subscriptions$: Subscription[] = [];
    gamblingControlURL: string;
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    ngOnInit(): void {
        this.isCountryUK = this.userdataService?.userData?.userInfo?.addressInfo?.country === 'GB';
        if (this.isCountryUK) {
            this.gamblingControlURL = this.userdataService?.userData?.configParams?.game_limits_url || ' ';
        }
        this.getBehaviorData();
    }

    getBehaviorData() {
        this.subscriptions$.push(
            this.behaviorData.showAdaInteractionMessage.subscribe((data) => {
                this.showAdaInteractionMessage = data;
                this.resizeService.resizeCashier();
            }),
        );
    }

    submitAdaDeposit() {
        this.depositService.showDepositFailure.set(false);
        this.resizeService.resizeCashier();
        this.behaviorData.changeAdaInteractionMessage(false);
        this.depositService.depositInfo.details.adaContinue = 'true';
        this.depositService.submitDeposit();
        this.GTMService.raiseEventForUnusualDeposit('continue', 'quick deposit', this.depositService?.depositInfo?.amountInfo?.nativeAmountString);
    }

    unblockForm() {
        this.behaviorData.changeEnteredAmount('');
        this.behaviorData.changeCVV2('');
        this.behaviorData.changeAdaInteractionMessage(false);
        this.resizeService.resizeCashier();

        let details = this.depositService?.depositInfo?.details || { adjustAmountCount: 1 };
        details.adjustAmountCount = (details.adjustAmountCount || 0) + 1;
        this.depositService.depositInfo.details = details;
        this.GTMService.raiseEventForUnusualDeposit('cancel', 'quick deposit', this.depositService?.depositInfo?.amountInfo?.nativeAmountString);
    }
    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
